import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography } from '@mui/material'
import * as Yup from 'yup'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../../components/input/NewInput'
import closeIcon from '../../../assets/icons/close.svg'
import { Dropdown } from 'primereact/dropdown'
import HorizontalLine from '../../../assets/icons/Line33.svg'
import pencilIcon from '../../../assets/icons/pencil1.svg'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { capitalizeFirstLetter, dynamicCustomFilter, handleInventory } from '../../../utility/genricFunction'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import RightDrawer from '../../../components/drawer/Drawer'
import ParentDataTable from '../../../components/data-table/ParentDataTable'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import UseAuthorization from '../../../utility/useAuthorization'
import Button from '../../../components/button/Button'
import Loader from '../../../components/loader/Loader'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import ModalUnstyled from '../../../components/model/Model'
import PopupBox from '../../../components/popup/PopupBox'
import { createBank, editBank, getAllBanks } from '../../../store/builders/MasterConfig/master.config.builder'
import '../designation/designation.scss'

const Banks = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { loading, banks } = useSelector((state) => state.masterConfig)
  const [archiveId, setArchiveId] = useState('')
  const [singleInventoryData, setSingleInventoryData] = useState('')


  useEffect(() => {
    dispatch(getAllBanks())
    return () => dispatch({ type: 'masterConfig/clearExtraReducers' })
  }, [])

  // const [loader, setLoader] = useState(true);

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    bankName: { value: null, matchMode: 'dynamic_custom' },
    bankStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [editInventoryDrawer, setEditInventoryDrawer] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber, setfilterNumber] = useState(false)

  const [selectedValue, setSelectedValue] = useState(null)

  const statuses = [
    { label: 'active', value: 'active' },
    { label: 'inactive', value: 'inactive' },
  ]

  useEffect(() => {
    setFilteredData(banks)
  }, [banks])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(banks, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForEditInventory = (newOpen, bank) => () => {
    setEditInventoryDrawer(newOpen)
    setIsOpen(true)
    setSingleInventoryData(bank)
  }

  const validationSchema = Yup.object().shape({
    bankName: Yup.string().required('Bank is required'),
  })

  const DrawerList = ({data, edit}) =>{

    const [initialValues, setInitialValues] = useState({
      bankId: data?.bankId ? data?.bankId : '',
      bankName: data?.bankName ? data?.bankName : '',
      status: data?.bankStatus ? data?.bankStatus : '',
    })

    return <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>{edit ? UI_CONSTANT.MASTER_CONFIG.BANKS.EDIT_BANK : UI_CONSTANT.MASTER_CONFIG.BANKS.ADD_BANK}</Typography>
        <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={toggleDrawer(false)} />
      </Box>
      <Box className='drawer-horizontal-line' />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validate={(value)=>{
        }}
        onSubmit={(value) => {

          if(edit){
            dispatch(editBank({value, setEditInventoryDrawer}))
          }else{
            dispatch(createBank({ bankName: value.bankName, dispatch, setOpen }))
          }

        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, errors }) => (
          <form>
            <div className='designation-field-wrapper flex justify-between'>
              <div className='designation-drawer-input'>
                <div className='designation-drawer-input-label'>
                  <NewInput
                    label='Bank Name'
                    placeholder='Enter Bank Name'
                    name='bankName'
                    width={'100%'}
                    required={true}
                    onInput={handleInventory}
                  />
                </div>
              </div>


              {edit  && <div className='designation-drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Bank Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}  
                    selectedValue={values.status}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'status'}
                    placeholder={'Select Bank Status'}
                  />
                  <ErrorMessage name='status' component='div' className='error-msg' />
                </div>}

            </div>

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
}

  const handleEditBankFormSubmit = (value) => {
    const data = {
      value,
      setEditInventoryDrawer
    }
    dispatch(editBank(data))
  }

  const EditBankData = (data) => {
    const editBankValidationSchema = Yup.object().shape({
      bankName: Yup.string().required('Bank name is required'),
      status: Yup.string().required('Bank status is required'),
    })
    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>{UI_CONSTANT.MASTER_CONFIG.BANKS.EDIT_BANK}</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForEditInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            bankId: data?.data?.bankId,
            bankName: data?.data?.bankName,
            status: data?.data?.bankStatus,
          }}
          validationSchema={editBankValidationSchema}
          onSubmit={(value) => {
            handleEditBankFormSubmit(value)
          }}
        >
          {({ handleSubmit, values,handleChange }) => (
            <form>
              <div className='designation-field-wrapper flex justify-between'>
                <div className='designation-drawer-input'>
                  <div className='designation-drawer-input-label'>
                    <NewInput
                      label='Bank Name'
                      placeholder='Enter Bank Name'
                      name='bankName'
                      width={'100%'}
                      required={true}
                      onInput={handleInventory}
                      value={values.bankName}
                    />
                  </div>
                </div>

                <div className='designation-drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Bank Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}  
                    selectedValue={values.status}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'status'}
                    placeholder={'Select Bank Status'}
                  />
                  <ErrorMessage name='status' component='div' className='error-msg' />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (bankTableData) => {
    const representative = bankTableData?.bankName && capitalizeFirstLetter(bankTableData?.bankName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (bankTableData) => {
    const representative = bankTableData?.bankStatus && capitalizeFirstLetter(bankTableData?.bankStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      />
    )
  }

  const handleArchiveConfirm = (inquiryId) => {
    // dispatch(inquiryArchive({ inquiryId })) // Example action
    setOpenArchive(false)
  }

  const verifiedBodyTemplate = (bankData) => {
    return (
      <>
        <PopupBox rowData={bankData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />

            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditInventory(true, bankData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>{UI_CONSTANT.MASTER_CONFIG.BANKS.EDIT_BANK}</p>
              </button>
            )}
          </div>
        </PopupBox>

        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
            className={'archive-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => handleArchiveConfirm(archiveId)}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'bankName',
      header: 'Bank Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'bankStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { minWidth: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MASTER_CONFIG.BANKS.LABEL_BANK,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.MASTER_CONFIG.BANKS.LABEL_BANK,
      link: ROUTES_PATH.BANKS,
    },
  ]

  return (
    <>
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {UseAuthorization(permissions.ADD_INVENTORY) && (
                <Button className='add-btn' onClick={toggleDrawer(true)}>
                  {UI_CONSTANT.MASTER_CONFIG.BANKS.ADD_BANK}
                </Button>
              )}
            </div>
            <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
              <DrawerList/>
            </RightDrawer>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper'>
                <b className='course-list1'>{UI_CONSTANT.MASTER_CONFIG.BANKS.ALL_BANKS}</b>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div id='inventory-list-table' className='table-card'>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                onFilter={onFilter}
              />
            </div>
          </div>
          {/* <9/div> */}
          {editInventoryDrawer && (
            <RightDrawer anchor='right' isOpen={editInventoryDrawer} onClose={toggleDrawerForEditInventory(false)}>
              <DrawerList data={singleInventoryData} edit={true}/>
            </RightDrawer>
          )}
        </div>
      )}
    </>
  )
}

export default Banks
